import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "../lib/menuData";

const Stat = ({ num, label }) => (
  <div>
    <div className="font-serif text-2xl sm:text-3xl md:text-5xl text-gold leading-none">{num}</div>
    <div className="text-cream/60 text-xs sm:text-sm mt-1.5">{label}</div>
  </div>
);

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "10%"]);

  return (
    <section id="herkunft" className="relative bg-teal py-24 md:py-36 grain">
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex items-center justify-between flex-wrap gap-4 mb-16">
          <Overline>Kapitel I — Über uns</Overline>
          <Reveal>
            <span className="font-serif text-8xl md:text-9xl text-gold/10 leading-none select-none">I</span>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div>
            <Reveal>
              <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl leading-[1.02] text-cream">
                Mit Herz, Erfahrung und einem neuen <span className="italic text-gold">Abholservice</span>.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 text-cream/75 text-base md:text-lg leading-relaxed max-w-xl">
                Mit langjähriger Erfahrung und viel Liebe zum Detail bringen wir die Aromen
                Sri Lankas und Südindiens nach Karlsruhe. In der Wilhelmstraße 43 starten wir
                unseren eigenen Abhol- und Lieferservice.
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="mt-5 text-cream/75 text-base md:text-lg leading-relaxed max-w-xl">
                Unsere Küche ist tamilisch und srilankisch: geröstete Gewürze, Kokos,
                Curryblätter und Rezepte über Generationen – frisch zubereitet,
                mit 10 % Online-Rabatt – zum Abholen oder frisch zu dir nach Hause geliefert.
              </p>
            </Reveal>
            <Reveal delay={0.26}>
              <div className="mt-12 grid grid-cols-3 gap-3 sm:gap-6 border-t border-gold/20 pt-8">
                <Stat num="7 Tage" label="geöffnet" />
                <Stat num="10 %" label="Online-Rabatt" />
                <Stat num="100%" label="Hausgemacht" />
              </div>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 gap-4 lg:grid-cols-5 lg:grid-rows-6 lg:h-[600px]">
            <Reveal className="h-64 lg:h-auto overflow-hidden rounded-sm border border-gold/20 lg:col-span-3 lg:row-span-4">
              <motion.img style={{ y: imgY }} src={IMAGES.aboutLeaf} alt="Srilankisches Gericht"
                className="h-full w-full object-cover scale-110" />
            </Reveal>
            <Reveal delay={0.15} className="h-56 lg:h-auto overflow-hidden rounded-sm border border-gold/20 lg:col-span-2 lg:row-span-3 lg:col-start-4 lg:row-start-2">
              <img src={IMAGES.aboutCurry} alt="Curry" className="h-full w-full object-cover" />
            </Reveal>
            <Reveal delay={0.25} className="bg-teal-dark border border-gold/25 rounded-sm p-6 flex flex-col justify-center lg:col-span-3 lg:row-span-2 lg:col-start-3 lg:row-start-5">
              <div className="overline mb-2">Handwerk</div>
              <p className="font-serif italic text-2xl text-cream leading-tight">
                „Jedes Gericht wird frisch zubereitet.“
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
